import React, { useMemo } from 'react';
import { getStandardQuestionTrends } from 'js/utils/standard-question-trends';
import TrendSetWithLegend from '../CapabilityTrendsChart/TrendSetWithLegend';

const STANDARD_TREND_ELEMENT = {
  guid: 'standard-questions',
  name: 'Scored standard questions',
};

/**
 * Scored Likert questions from standard pages, one line per question. Shows
 * nothing until a run has asked one.
 */
export function StandardTrendsChart({ userGroupAssessments }) {
  const { questions, trends, metrics } = useMemo(
    () => getStandardQuestionTrends(userGroupAssessments),
    [userGroupAssessments]
  );

  const trendSet = useMemo(
    () => [{ element: STANDARD_TREND_ELEMENT, capabilityTrends: trends }],
    [trends]
  );

  if (Object.keys(questions).length === 0) {
    return null;
  }

  return (
    <div className="mt-4">
      <TrendSetWithLegend
        trends={trendSet}
        metrics={metrics}
        items={questions}
      />
    </div>
  );
}

export default StandardTrendsChart;
